(function(){
    'use strict'

    angular
    .module('app.deducibles')
    .controller('EditarOtroDeducible', EditarOtroDeducible);

    EditarOtroDeducible.$inject = ['$compile', '$q', '$scope', '$animationsSrv', '$routeParams','DeduciblesService', 'TiposDeduciblesService', 'DevengadosService', 'CantidadesService', 'VariablesService', 'logger', '$location', 'CuentasContablesService', 'AreasService', 'UserInfoService', 'CoreSrv'];

    function EditarOtroDeducible($compile, $q, $scope, $animationsSrv, $routeParams, DeduciblesService, TiposDeduciblesService, DevengadosService, CantidadesService, VariablesService, logger, $location, CuentasContablesService, AreasService, UserInfoService, CoreSrv) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;
        vm.tipos = [];
        vm.cantidades = [];
        vm.deducibles = [];
        vm.devengados = [];
        vm.variables = [];
        vm.empleadoPropiedades = [];
        vm.periodoPropiedades = [];
        vm.asociacionPropiedades = [];
        vm.cuentas = [];
        vm.areas = [];

        vm.deducible = {
            tipo: -1,
            cantidadId: -1,
            deduccionId: -1,
            devengadoId: -1,
            variableId: -1,
            empleadoId: '-1',
            periodoId: '-1',
            asociacionId: '-1',
            formula: '',
            predeterminado: false,
            esFijo: false,
            incluirAsiento: false,
            cuentaId: -1,
            areaId: -1,
            aplicarSoloUltimaPlanillaMes: false
        };

        vm.deducibleId = $routeParams.id ? $routeParams.id : 0;

        getEmpleadoData();
        getPeriodoData();
        getAsociacionData();
        var promiseTipos = getTipos();
        var promiseCantidades = getCantidades();
        var promiseDevengados = getDevengados();
        var promiseVariables = getVariables();
        var promiseDeducibles = getDeducibles();
        var promiseCuentas = getCuentas();
        var promiseAreas = getAreas();

        CargarDeducible();

        function getEmpleadoData()
        {
            vm.empleadoPropiedades = CoreSrv.getPropiedadesEmpleado();
        };

        function getPeriodoData()
        {
            vm.periodoPropiedades = CoreSrv.getPropiedadesPeriodo();
        };

        function getAsociacionData()
        {
            vm.asociacionPropiedades = CoreSrv.getPropiedadesAsociacion();
        };

        function getTipos(){
            var promise = TiposDeduciblesService.getAll()
            .then(function(tipos){
                vm.tipos = tipos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos.');
            }); 
            
            return promise;
        };

        function getCantidades(){
            var promise = CantidadesService.getAll()
            .then(function(cantidades){
                vm.cantidades = cantidades;
            })
            .catch(function(error){
                $logger.error('Error al obtener las cantidades.');
            }); 
            
            return promise;
        };

        function getDevengados(){
            var promise = DevengadosService.getAll()
            .then(function(devengados){
                vm.devengados = devengados;
            })
            .catch(function(error){
                $logger.error('Error al obtener los devengados.');
            }); 
            
            return promise;
        };

        function getVariables(){
            var promise = VariablesService.getAll()
            .then(function(variables){
                vm.variables = variables;
            })
            .catch(function(error){
                $logger.error('Error al obtener las variables.');
            }); 
            
            return promise;
        };

        function getDeducibles(){
            var promise = DeduciblesService.getAllOtros()
            .then(function(deducibles){
                vm.deducibles = deducibles;
            })
            .catch(function(error){
                $logger.error('Error al obtener los deducibles.');
            }); 
            
            return promise;
        };

        function getCuentas(){
            var promise = CuentasContablesService.getAll(UserInfoService.getCompaniaId())
            .then(function(cuentas){
                vm.cuentas = cuentas;
            })
            .catch(function(error){
                $logger.error('Error al obtener las cuentas.');
            }); 
            
            return promise;
        };

        function getAreas(){
            var promise = AreasService.getAll(UserInfoService.getCompaniaId())
            .then(function(areas){
                vm.areas = areas;
            })
            .catch(function(error){
                $logger.error('Error al obtener las areas.');
            }); 
            
            return promise;
        };

        function CargarDeducible(){
            $q.all([promiseTipos, promiseCantidades, promiseDevengados, promiseVariables, promiseDeducibles, promiseCuentas, promiseAreas]).then(getDeducible);
        }

        function getDeducible(){

            if(vm.deducibleId != 0){
                var promise = DeduciblesService.getByIdOtros(vm.deducibleId);

                promise
                .then(function(deducible){
                    deducible.cuentaId = deducible.cuentaId == null ? -1 : deducible.cuentaId;
                    deducible.areaId = deducible.areaId == null ? -1 : deducible.areaId;
                    vm.deducible = deducible;
                    vm.deducible.cantidadId = -1;
                    vm.deducible.deduccionId = -1;
                    vm.deducible.devengadoId = -1;
                    vm.deducible.variableId = -1;
                    vm.deducible.empleadoId = '-1';
                    vm.deducible.periodoId = '-1';
                    vm.deducible.asociacionId = '-1';

                    var formulaHtml = $(vm.deducible.formulaHtml);
                    $compile(formulaHtml) ($scope);
                    formulaHtml.appendTo($('.formula'));

                })
                .catch(function(error){
                    switch (error.status) {
                        case 401:
                            logger.error('La sesión ha expirado');
                            break;
                    
                        default:
                            logger.error('Hubo un error al obtener el deducible: ' + error.data.Message);
                            break;
                    }
                });               
            }

        };

        vm.save = function(){

            $scope.submitted = true;

            if(vm.deducible.tipo == -1){
                $scope.deducibleForm.tipoId.$setValidity("different", false);
            }

            if($scope.deducibleForm.$valid){
                if(!vm.deducible.id){
                    saveDeducible();
                }
                else if($scope.deducibleForm.$dirty){
                    updateDeducible();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function saveDeducible() {
            var promise = DeduciblesService.saveOtros(vm.deducible);
            
            promise
            .then(function(response){
                logger.success('Deducible creado con éxito.');
                clearDeducibleData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear el deducible: ' + error.data.Message);
                        break;
                }
            });   
        };

        function updateDeducible(){
            var promise = DeduciblesService.updateOtros(vm.deducible);
            
            promise
            .then(function(response){
                logger.success('Deducible modificado con éxito.');
                $location.path('/otros-deducibles');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar el deducible: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearDeducibleData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.deducible = {
                tipo: -1,
                cantidadId: -1,
                deduccionId: -1,
                devengadoId: -1,
                variableId: -1,
                empleadoId: '-1',
                periodoId: '-1',
                asociacionId: '-1',
                formula: '',
                predeterminado: false,
                esFijo: false,
                incluirAsiento: false,
                cuentaId: -1,
                areaId: -1,
                aplicarSoloUltimaPlanillaMes: false
            };
            // Set back to pristine.
            $scope.deducibleForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.deducibleForm.$setUntouched();
        };

        vm.variablesChange = function(){
            addvalueToFormula(vm.variables, vm.deducible.variableId, '#');

        };

        vm.devengadosChange = function(){
            addvalueToFormula(vm.devengados, vm.deducible.devengadoId, '&');
        };

        vm.deduciblesChange = function () {
            addvalueToFormula(vm.deducibles, vm.deducible.deduccionId, '');
        };

        vm.cantidadesChange = function(){
            addvalueToFormula(vm.cantidades, vm.deducible.cantidadId, '@');
        };

        vm.empleadoChange = function(){

            if(vm.deducible.empleadoId == '-1') return;

            setFormulaValue('$' + vm.deducible.empleadoId);
        };

        vm.periodoChange = function(){
            
            if(vm.deducible.periodoId == '-1') return;

            setFormulaValue('~' + vm.deducible.periodoId);
        };

        vm.asociacionChange = function(){
            
            if(vm.deducible.asociacionId == '-1') return;

            setFormulaValue('_' + vm.deducible.asociacionId);
        };

        vm.tiposChange = function(){
            if(vm.deducible.tipo == -1){
                $scope.deducibleForm.tipoId.$setValidity("different", false);
            }
            else{
                $scope.deducibleForm.tipoId.$setValidity("different", true);
            }
        };

        function addvalueToFormula(currentList, modelValue, prefix){
            var item = currentList.find(function(el){
                return el.id == modelValue;
            });

            if(item && item.codigo){

                setFormulaValue(prefix + item.codigo);
            }
        };

        function setFormulaValue(value){
            if(vm.deducible.formula == undefined || vm.deducible.formula == null) vm.deducible.formula = '';

            var formulaInput = document.getElementById("myformula");
            var start = formulaInput.selectionStart;
            var end = formulaInput.selectionEnd;

            // update the value with our text inserted
            vm.deducible.formula = vm.deducible.formula.slice(0, start) + value + vm.deducible.formula.slice(end);

            // update cursor to be at the end of insertion
            formulaInput.selectionStart = formulaInput.selectionEnd = start + value.length;

        };

    }
})();